'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIntl = require('react-intl');

var _reactRedux = require('react-redux');

var _reactRouterRedux = require('react-router-redux');

var _Captcha = require('../../helpers/Captcha');

var _DefaultString = require('../../helpers/DefaultString');

var _Error = require('../../helpers/Error');

var _PopupType = require('../../helpers/PopupType');

var _Product = require('../../helpers/Product');

var _Router = require('../../helpers/Router');

var _PostLoginFlowStrategySelector = require('../../login/strategy/PostLoginFlowStrategySelector');

var _PostLoginFlowStrategySelector2 = _interopRequireDefault(_PostLoginFlowStrategySelector);

var _auth = require('../../redux/modules/auth');

var _captcha = require('../../redux/modules/captcha');

var _popup = require('../../redux/modules/popup');

var _Captcha2 = require('./Captcha.scss');

var _Captcha3 = _interopRequireDefault(_Captcha2);

var _reactGoogleRecaptcha = require('react-google-recaptcha');

var _reactGoogleRecaptcha2 = _interopRequireDefault(_reactGoogleRecaptcha);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CAPTCHA_THEME = {
  DARK: 'dark',
  LIGHT: 'light'
};

var Captcha = (_temp2 = _class = function (_Component) {
  (0, _inherits3.default)(Captcha, _Component);

  function Captcha() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Captcha);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Captcha.__proto__ || (0, _getPrototypeOf2.default)(Captcha)).call.apply(_ref, [this].concat(args))), _this), _this.onReCaptchaChange = function (response) {
      _this.props.editCaptchaError(false);
      _this.props.editCaptchaToken(response);
      if (_this.props.onReCaptchaValidated) {
        _this.props.onReCaptchaValidated(response);
      }
    }, _this.onRequestError = function (response) {
      _this.resetCaptcha();
      if (response.code === _Error.ErrorConst.InvalidCaptcha) {
        _this.showCaptcha();
      }
    }, _this.onLoginSignUpError = function (errorResponse) {
      if (errorResponse) {
        var responseBody = errorResponse.body;
        _this.resetCaptcha();
        if (responseBody.code === _Error.ErrorConst.InvalidValue && responseBody.field === _Error.ErrorFieldConst.EmailPassword) {
          (0, _Captcha.isCaptchaExpectedBehavior)(responseBody, _this.props.changeCaptchaRequired, _this.props.initLang, _this.props.lang);
        } else if (responseBody.code === _Error.ErrorConst.InvalidCaptcha) {
          _this.showCaptcha();
        }
      }
    }, _this.onLoginSignUpSuccess = function (auth) {
      if (auth.termsPrivacy || _this.autoApproveAgreements()) {
        _this.props.approveAgreements();
      } else {
        var loginStrategy = _PostLoginFlowStrategySelector2.default.getPostLoginFlowStrategy(auth, _this.props.appInfo, _this.props.pushState, _this.props.log);
        loginStrategy.handleUserInfoResponse(_this.props.linkIdentityToAccount, _this.props.linkSecureToken, _this.props.linkSSOToken);
      }
    }, _this.getTheme = function () {
      var theme = CAPTCHA_THEME.LIGHT;
      if (_this.props.auth.productName === _Product.PRODUCT_NAMES.Classica || _this.props.auth.productName === _Product.PRODUCT_NAMES.Qello) {
        theme = CAPTCHA_THEME.DARK;
      }
      return theme;
    }, _this.autoApproveAgreements = function () {
      return _this.props.appInfo.agreement && _this.props.appInfo.agreement[_this.props.auth.productName] && _this.props.appInfo.agreement[_this.props.auth.productName].auto;
    }, _this.showCaptcha = function () {
      // If we need to reload the page to correctly show the captcha (current language)
      if (!(0, _Captcha.needToReloadPageForCaptcha)(_this.props.initLang, _this.props.lang)) {
        _this.props.changeCaptchaRequired(true);
      }
    }, _this.resetCaptcha = function () {
      // Reset the captcha because the request failed
      if (window.grecaptcha && _this.props.captcha.needCaptcha) {
        _this.props.editCaptchaToken('');
        window.grecaptcha.reset();
      }
      _this.props.editCaptchaError(false);
    }, _this.executeReCaptcha = function () {
      if (_this.captchaEl && _this.captchaEl.execute) {
        _this.captchaEl.execute();
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(Captcha, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      this.props.captchaTypeRequired.forEach(function (captchaType) {
        _this2.props.captchaRequired(captchaType);
      });
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      // Login
      if (this.props.auth.loggingIn && !nextProps.auth.loggingIn) {
        if (nextProps.auth.loginError) {
          this.onLoginSignUpError(nextProps.auth.loginError.response);
        } else {
          this.onLoginSignUpSuccess(nextProps.auth);
        }
      } else if (this.props.auth.forgotPassword && !nextProps.auth.forgotPassword) {
        // Forgot Password
        this.resetCaptcha();
        if (nextProps.auth.response && nextProps.auth.response.captchaRequired) {
          this.showCaptcha();
        } else if (nextProps.auth.forgotPasswordError && nextProps.auth.forgotPasswordError.response) {
          this.onRequestError(nextProps.auth.forgotPasswordError.response.body);
        }
      } else if (this.props.auth.emailExists && !nextProps.auth.emailExists) {
        // Email Exists
        var response = nextProps.auth.response;
        var error = nextProps.auth.error;
        this.resetCaptcha();
        if (response && response.captchaRequired) {
          this.showCaptcha();
        } else if (error && error.response) {
          this.onRequestError(error.response.body);
        }
      } else if (this.props.auth.creatingAccount && !nextProps.auth.creatingAccount) {
        // Sign Up (Create Account)
        if (nextProps.auth.error) {
          this.onLoginSignUpError(nextProps.auth.error.response);
        } else {
          this.onLoginSignUpSuccess(nextProps.auth);
        }
      } else if (this.props.auth.appleLoggingIn && !nextProps.auth.appleLoggingIn) {
        // Apple Login
        if (nextProps.auth.error) {
          this.onLoginSignUpError(nextProps.auth.error.response);
        } else {
          this.onLoginSignUpSuccess(nextProps.auth);
        }
      } else if (this.props.auth.fbLoggingIn && !nextProps.auth.fbLoggingIn) {
        // Facebook Login
        if (nextProps.auth.error) {
          this.onLoginSignUpError(nextProps.auth.error.response);
        } else {
          this.onLoginSignUpSuccess(nextProps.auth);
        }
      } else if (this.props.auth.googleLoggingIn && !nextProps.auth.googleLoggingIn) {
        // Google Login
        if (nextProps.auth.error) {
          this.onLoginSignUpError(nextProps.auth.error.response);
        } else {
          this.onLoginSignUpSuccess(nextProps.auth);
        }
      } else if (this.props.auth.linkingIdentityToAccount && !nextProps.auth.linkingIdentityToAccount) {
        // Link Identity to Account
        if (nextProps.auth.error) {
          this.props.changePopupType(_PopupType.PopupId.UnknownError); // TODO GALVIP-3063 Error
        } else {
          this.onLoginSignUpSuccess(nextProps.auth);
        }
      } else if (this.props.auth.linkingSecureToken && !nextProps.auth.linkingSecureToken || this.props.auth.linkingSSOToken && !nextProps.auth.linkingSSOToken) {
        if (nextProps.auth.error) {
          this.props.pushState((0, _Router.getPath)(_Router.RouterConst.Welcome + '/' + _Router.RouterConst.LinkExpired));
        } else {
          this.onLoginSignUpSuccess(nextProps.auth);
        }
      } else if (this.props.auth.gettingApproveAgreements && !nextProps.auth.gettingApproveAgreements) {
        if (nextProps.auth.error) {
          this.props.changePopupType(_PopupType.PopupId.UnknownError);
        } else {
          var loginStrategy = _PostLoginFlowStrategySelector2.default.getPostLoginFlowStrategy(nextProps.auth, this.props.appInfo, this.props.pushState, this.props.log);
          loginStrategy.handleUserInfoResponse(this.props.linkIdentityToAccount, this.props.linkSecureToken, this.props.linkSSOToken);
        }
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.props.changeCaptchaRequired(false);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var siteKey = this.props.appInfo.captchaSiteKey;
      var error = this.props.error;

      var hasCaptcha = this.props.captcha.needCaptcha;
      var recaptchaClassName = _Captcha3.default.recaptchaContent + (error ? ' ' + _Captcha3.default.error : '');
      var theme = this.getTheme();

      return _react2.default.createElement(
        'div',
        { className: recaptchaClassName },
        error ? _react2.default.createElement(
          'div',
          { className: _Captcha3.default.errorMessage },
          _react2.default.createElement(_reactIntl.FormattedMessage, _DefaultString.translations.CaptchaErrorMessage)
        ) : '',
        hasCaptcha ? _react2.default.createElement(
          'div',
          { className: _Captcha3.default.recaptcha },
          _react2.default.createElement(_reactGoogleRecaptcha2.default, {
            ref: function ref(el) {
              _this3.captchaEl = el;
            },
            sitekey: siteKey,
            onChange: this.onReCaptchaChange,
            theme: theme,
            size: 'invisible'
          })
        ) : _react2.default.createElement('div', { className: _Captcha3.default.emptyCaptcha })
      );
    }
  }]);
  return Captcha;
}(_react.Component), _class.propTypes = {
  appInfo: _react.PropTypes.object,
  approveAgreements: _react.PropTypes.func,
  auth: _react.PropTypes.object,
  captcha: _react.PropTypes.object,
  changeCaptchaRequired: _react.PropTypes.func,
  captchaRequired: _react.PropTypes.func,
  captchaTypeRequired: _react.PropTypes.array.isRequired,
  changePopupType: _react.PropTypes.func,
  editCaptchaToken: _react.PropTypes.func,
  editCaptchaError: _react.PropTypes.func,
  error: _react.PropTypes.bool,
  initLang: _react.PropTypes.string,
  lang: _react.PropTypes.string,
  linkIdentityToAccount: _react.PropTypes.func,
  linkSecureToken: _react.PropTypes.func,
  linkSSOToken: _react.PropTypes.func,
  log: _react.PropTypes.object,
  onReCaptchaValidated: _react.PropTypes.func,
  pushState: _react.PropTypes.func.isRequired
}, _temp2);
exports.default = (0, _reactRedux.connect)(function (state) {
  return {
    appInfo: state.appInfo,
    auth: state.auth,
    captcha: state.captcha,
    initLang: state.auth.initLang,
    lang: state.auth.lang,
    log: state.log };
}, { approveAgreements: _auth.approveAgreements, captchaRequired: _captcha.captchaRequired, changeCaptchaRequired: _captcha.changeCaptchaRequired, changePopupType: _popup.changePopupType, editCaptchaToken: _captcha.editCaptchaToken, linkIdentityToAccount: _auth.linkIdentityToAccount, linkSecureToken: _auth.linkSecureToken, linkSSOToken: _auth.linkSSOToken, pushState: _reactRouterRedux.push }, null, { withRef: true })(Captcha);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Captcha/Captcha.js
// module id = 1945
// module chunks = 0